<template>
  <div class="turnover-scroll-container">
    <div class="turnover-flex-wrapper">
      <div class="turnover-compact" v-for="year in processedTurnover" :key="year.year">
        <div class="compact-year" :class="{ 'current-year': year.year == new Date().getFullYear() }">
          <div style="font-size: 19px; font-weight: bold;">{{ year.year }}</div>
        </div>
        <div class="compact-metrics-vertical">
          <div class="compact-metric-row">
            <div class="compact-metric-label">Sales</div>
            <div class="compact-metric-value">{{ Number(year.verkoop).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' }) }}</div>
          </div>
          <div class="compact-metric-row">
            <div class="compact-metric-label">Purchase</div>
            <div class="compact-metric-value">{{ Number(year.inkoop).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' }) }}</div>
          </div>         
          <div class="compact-metric-row">
            <div class="compact-metric-label">Margin</div>
            <div class="compact-metric-value">{{ (Number(year.marge)).toFixed(2) }}%</div>
          </div>                    
          <div class="compact-metric-row">
            <div class="compact-metric-label">Stays</div>
            <div class="compact-metric-value">{{ year.stays }}</div>
          </div>     
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YearTurnover',
  props: {
    turnover: {
      type: Array,
      required: true,
      default: () => []
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // console.log('calculation acco mounted', this.$session.id());
  },  
  computed: {
    processedTurnover() {
      if (this.reverse) {
        return this.turnover.slice().reverse();
      }
      return this.turnover;
    }
  }
}
</script>

<style scoped>
.turnover-scroll-container {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px 0;
  padding-bottom: 4px;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}

.turnover-scroll-container::-webkit-scrollbar {
  height: 6px;
}

.turnover-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}

.turnover-scroll-container::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 3px;
}

.turnover-scroll-container::-webkit-scrollbar-thumb:hover {
  background-color: #999;
}

.turnover-flex-wrapper {
  display: flex;
  flex-direction: row;
  gap: 10px;
  min-width: 100%;
  width: max-content;
}

.turnover-compact {
  display: flex;
  background: linear-gradient(90deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  flex-shrink: 0;
  flex-grow: 1;
  min-width: 200px;
  max-width: 280px;
}

.turnover-compact:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.compact-year {
  background: #1976d2;
  color: white;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 70px;
}

.compact-metrics-vertical {
  flex: 1;
  padding: 12px 12px 8px 12px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 6px;
  min-width: 130px;
}

.compact-metric-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1.1;
}

.compact-metric-label {
  font-size: 10px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-right: 8px;
}

.compact-metric-value {
  font-weight: 600;
  font-size: 10px;
  color: #1976d2;
  text-align: right;
  flex-shrink: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.current-year {
  background: #4CAF50 !important;
}

@media (max-width: 768px) {
  .turnover-compact {
    min-width: 100%;
    margin-bottom: 8px;
  }
}
</style>